import {InfoPage, RsnButton, RsnDialog, RsnTextButton} from '@raison/ui-kit';
import React from 'react';
import {Currency} from '~/entities/currencies';
import {useSearchModel} from '~/processes/crypto-send-and-receive/lib/useSearchModel';
import {TrTx} from '~/processes/crypto-send-and-receive/model/TrTx';
import {TrtDetailsDialog} from '~/processes/crypto-send-and-receive/ui/SentTrTxDetailsDialog';
import {ParamKey, useGoHome, useGoToSupport} from '../model/SendTxRouting';

export function TrTxRejectedPage({currency, trt}: {currency: Currency; operation: 'Send' | 'Receive'; trt: TrTx}) {
    const [params, searchCtl] = useSearchModel({
        [ParamKey.dialog]: {details: 'details'},
    });

    const t = {
        Heading: 'Your transaction has been rejected',
        Details: (
            <span>
                You have provided incorrect information, or we are unable to complete your transaction for other
                reasons. If you have any questions, please{' '}
                <RsnTextButton.Inline onClick={useGoToSupport()}>contact support</RsnTextButton.Inline>.
            </span>
        ),
        BackToHome: 'Back to home',
        ContactSupport: 'Contact support',
        ViewDetails: 'View operation details',
    };
    return (
        <InfoPage.Layout symbol='failure' title={`Send ${currency.code}`}>
            {{
                center: (
                    <InfoPage.Center heading={t.Heading} details={t.Details}>
                        <RsnTextButton.Block decoration='arrow-right' onClick={searchCtl.goTo.dialog.details}>
                            {t.ViewDetails}
                        </RsnTextButton.Block>
                    </InfoPage.Center>
                ),
                footer: (
                    <InfoPage.Footer>
                        <RsnButton.Primary onClick={useGoHome()}>{t.BackToHome}</RsnButton.Primary>
                        <RsnDialog.Controller onClose={searchCtl.undo.dialog}>
                            {params.dialog === 'details' && <TrtDetailsDialog trt={trt} amounts={null}  />}
                        </RsnDialog.Controller>
                    </InfoPage.Footer>
                ),
            }}
        </InfoPage.Layout>
    );
}
